import type { Clean } from './types'
import { isPencilledVisit } from './planning'
import { visitWords, type WordsCustomer, type WordsVisit } from './visit-words'

// Pencilled means the DAY is not agreed. Time-only agreement stays amber on the visit.
// One predicate in planning.ts owns all exclusions and is shared with day colours and marks.
export type PencilledStep = 'ask' | 'waiting'
export const PENCILLED_STEPS: readonly PencilledStep[] = ['ask', 'waiting']
export const STEP_TITLES: Record<PencilledStep, string> = { ask: 'Not asked yet', waiting: 'Asked, waiting' }
export const STEP_NOTES: Record<PencilledStep, string> = { ask: 'message them about their day', waiting: 'nothing to do unless you chase' }

type PencilVisit = WordsVisit & Pick<Clean, 'date' | 'confirmed' | 'source' | 'created_by'> & { job_id?: number | null }

export function pencilledStep(v: PencilVisit, c: WordsCustomer | null, today: string): PencilledStep | null {
  if (!isPencilledVisit(v, c, today)) return null
  // The day's own words (visit-words.ts) already know who has been asked: the first job's message history, an extra
  // job's own, days offered, a message about another day, a move nobody has been told about.
  const day = visitWords(v, c, today).day
  if (day === 'Not asked yet' || day.endsWith('about another day, no reply') || day.startsWith('Moved from')) return 'ask'
  return 'waiting'
}

export interface PencilledCount { all: number; ask: number; waiting: number }
export function countPencilled(steps: (PencilledStep | null)[]): PencilledCount {
  const n: PencilledCount = { all: 0, ask: 0, waiting: 0 }
  for (const s of steps) if (s) { n.all++; n[s]++ }
  return n
}

// "14 pencilled · 8 to ask"; "14 pencilled" when nobody is left to ask; "" when none.
export function pencilledWords(n: PencilledCount): string {
  if (!n.all) return ''
  return n.ask ? `${n.all} pencilled · ${n.ask} to ask` : `${n.all} pencilled`
}
